import gql from 'graphql-tag';

export const adBlueprintQuery = gql`
  query getAllAdBlueprints {
    adBlueprints: allAdBlueprints {
      list: nodes {
        id
        name
        adAccount
        page
        adType
        canvasId
        carouselId
        urlValues
        headline
        adCopy
        asset
        linkDescription
        displayLink
        createdAt
        createdBy
        updatedAt
        updatedBy
        imageUrl
      }
    }
  }
`;

export const deleteAdBlueprint = gql`
  mutation($id: Int!) {
    deleteAdBlueprintById(input: { id: $id }) {
      adBlueprint {
        id
        name
        adAccount
        page
        adType
        canvasId
        carouselId
        urlValues
        headline
        adCopy
        asset
        linkDescription
        displayLink
        createdAt
        createdBy
        updatedAt
        updatedBy
        imageUrl
      }
    }
  }
`;

export const getAllCanvases = gql`
  query getAllCanvases {
    canvases: allCanvas {
      list: nodes {
        id
        name
        theme
        headline
        copy
        createdAt
        createdBy
        updatedAt
        updatedBy
        enableSwipe
      }
    }
    canvasPhoto: allCanvasPhotos {
      list: nodes {
        id
        name
        imageUrl
        targetUrl
        option
        canvasId
        order
      }
    }
    canvasVideo: allCanvasVideos {
      list: nodes {
        id
        name
        videoUrl
        option
        canvasId
        order
      }
    }
    canvasCarousel: allCanvasCarousels {
      list: nodes {
        id
        name
        option
        canvasId
        order
      }
    }
    canvasCarouselCard: allCanvasCarouselCards {
      list: nodes {
        id
        name
        imageUrl
        targetUrl
        carouselId
      }
    }
    canvasTile: allCanvasTiles {
      list: nodes {
        id
        name
        asset
        imageUrl
        canvasId
      }
    }
  }
`;

export const submitAdBlueprint = gql`
  mutation($adBlueprint: AdBlueprintInput!) {
    createAdBlueprint(input: { adBlueprint: $adBlueprint }) {
      adBlueprint {
        id
        name
        adAccount
        page
        adType
        canvasId
        carouselId
        urlValues
        headline
        adCopy
        asset
        linkDescription
        displayLink
        createdAt
        createdBy
        updatedAt
        updatedBy
        imageUrl
      }
    }
  }
`;

const adBlueprintByAccountIdQuery = gql`
  query($adAccount: String!) {
    adBlueprint: allAdBlueprints(condition: { adAccount: $adAccount }) {
      nodes {
        id
        name
        adAccount
        page
        adType
        canvasId
        carouselId
        urlValues
        headline
        adCopy
        asset
        linkDescription
        displayLink
        createdAt
        createdBy
        updatedAt
        updatedBy
        imageUrl
      }
    }
  }
`;

export const updateAdBlueprint = gql`
  mutation($id: Int!, $adBlueprint: AdBlueprintPatch!) {
    updateAdBlueprintById(input: { id: $id, adBlueprintPatch: $adBlueprint }) {
      adBlueprint {
        name
        adAccount
        page
        adType
        canvasId
        carouselId
        urlValues
        headline
        adCopy
        asset
        linkDescription
        displayLink
        updatedAt
        updatedBy
        imageUrl
      }
    }
  }
`;

export async function getAdBlueprintByAccountId(adAccount) {
  const client = window.__APOLLO_CLIENT__;
  const queryResult = await client.query({
    query: adBlueprintByAccountIdQuery,
    variables: { adAccount }
  });
  return queryResult.data.adBlueprint.nodes;
}

export async function getCanvases() {
  const client = window.__APOLLO_CLIENT__;
  const queryResult = await client.query({
    query: getAllCanvases
  });
  return queryResult.data;
}



// WEBPACK FOOTER //
// ./src/database/AdBlueprintDB.js